export default "<div #pixic class=\"canvas-container\"></div>\n\n<wg-hud-container></wg-hud-container>\n";